import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import { TLoanId } from '/src/lib/models';
import type {
  TCreateLoanRequest,
  TCreateLoanResponse,
  TDeleteLoanResponse,
  TGetLoanNameResponse,
  TGetLoanResponse,
  TListLoansRequest,
  TListLoansResponse,
  TUpdateLoanRequest,
  TUpdateLoanResponse,
} from '/src/lib/types';

export class LoanService {
  /**
   * List Loans
   * @returns Loan[]
   * @throws ApiError
   */
  public static async query(req?: TListLoansRequest): CancelablePromise<TListLoansResponse> {
    const res = (await __request(OpenAPI, {
      method: 'GET',
      url: '/loans',
      query: req,
    })) as TListLoansResponse;

    return res;
  }

  /**
   * Get Loan Name
   * @param id TLoanId
   * @returns Loan
   * @throws ApiError
   */
  public static async getName(id: TLoanId): CancelablePromise<TGetLoanNameResponse> {
    const res = (await __request(OpenAPI, {
      method: 'GET',
      url: '/loans/{id}',
      path: { id },
      query: {
        include: '{_id,name}',
      },
    })) as TGetLoanNameResponse;

    return res;
  }

  /**
   * Get Loan
   * @param id TLoanId
   * @returns Loan
   * @throws ApiError
   */
  public static async get(id: TLoanId): CancelablePromise<TGetLoanResponse> {
    const res = (await __request(OpenAPI, {
      method: 'GET',
      url: '/loans/{id}',
      path: { id },
    })) as TGetLoanResponse;

    return res;
  }

  /**
   * Create Loan
   * @param loan Loan
   * @returns Loan
   * @throws ApiError
   */
  public static async create(req: TCreateLoanRequest): CancelablePromise<TCreateLoanResponse> {
    const res = (await __request(OpenAPI, {
      method: 'POST',
      url: '/loans',
      body: req,
    })) as TCreateLoanResponse;

    return res;
  }

  /**
   * Update Loan
   * @param loan Loan
   * @returns Loan
   * @throws ApiError
   */
  public static async update(id: TLoanId, req: TUpdateLoanRequest): CancelablePromise<TUpdateLoanResponse> {
    const res = (await __request(OpenAPI, {
      method: 'PUT',
      url: '/loans/{id}',
      path: { id },
      body: req,
    })) as TUpdateLoanResponse;

    return res;
  }

  /**
   * Delete Loan
   * @param id TLoanId
   * @returns Loan
   * @throws ApiError
   */
  public static async remove(id: TLoanId): CancelablePromise<TDeleteLoanResponse> {
    const res = (await __request(OpenAPI, {
      method: 'DELETE',
      url: '/loans/{id}',
      path: { id },
    })) as TDeleteLoanResponse;

    return res;
  }
}
